import React, { useEffect, useRef, useState } from "react";

// 記事編集のサブカテゴリー選択（TGW-2543）。
// ネイティブの <select> は Mac で「選択中の項目が欄に重なる位置」に開き、選び直すたびに出る位置が変わるため、
// 常に欄の下へ開く自前のプルダウンにしている。キーボードは閉じた <select> と同じく ↑↓ で前後の値へ移る。
const SubCategorySelect = ({ value, options, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);
  const selectedItemRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    selectedItemRef.current && selectedItemRef.current.scrollIntoView({ block: "nearest" });
    const closeOnOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setIsOpen(false);
    };
    const closeOnEscape = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isOpen]);

  const items = [{ id: "", label: "なし（単発記事）" }, ...options];
  const selectedIndex = items.findIndex((item) => String(item.id) === String(value));
  // 選択肢に無い値は model 側で末尾に補っているが、万一無くても「なし」と見せない
  const selectedLabel = selectedIndex >= 0 ? items[selectedIndex].label : `ID: ${value}`;

  const select = (id) => {
    onChange(String(id));
    setIsOpen(false);
  };

  const onKeyDown = (e) => {
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    e.preventDefault();
    const next = selectedIndex + (e.key === "ArrowDown" ? 1 : -1);
    if (next >= 0 && next < items.length) onChange(String(items[next].id));
  };

  // Tab 等でフォーカスが部品の外へ出たら閉じる
  const onBlur = (e) => {
    if (rootRef.current && !rootRef.current.contains(e.relatedTarget)) setIsOpen(false);
  };

  return (
    <div ref={rootRef} className="position-relative" onBlur={onBlur}>
      <button
        type="button"
        className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark text-left bg-white text-truncate"
        style={{ paddingRight: "2rem" }}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={onKeyDown}
      >
        {selectedLabel}
      </button>
      {isOpen && (
        <ul
          role="listbox"
          className="list-unstyled bg-white border rounded shadow-sm mb-0 py-1"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 1000,
            maxHeight: "320px",
            overflowY: "auto",
          }}
        >
          {items.map((item, index) => {
            const isSelected = index === selectedIndex;
            return (
              <li
                key={item.id === "" ? "none" : item.id}
                ref={isSelected ? selectedItemRef : null}
                role="option"
                aria-selected={isSelected}
                className={`px-3 py-2 text-fz-14px ${isSelected ? "bg-light text-fw-bold" : ""}`}
                style={{ cursor: "pointer" }}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => select(item.id)}
              >
                {item.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SubCategorySelect;
